import { Box, SxProps, Typography, Stack } from '@mui/material';

interface Props {
  children: JSX.Element | JSX.Element[];
  title: string;
  sx?: SxProps;
  bg?: string;
  hideShadow?: boolean;
  actionPanel?: any;
}

const TileWrapper: React.FC<Props> = ({ children, title, sx, bg, hideShadow, actionPanel }) => {
  return (
    <Box className='tileWrapper' sx={{ p: { xs: 2, sm: 3 }, boxShadow: !hideShadow ? 3 : 0, height: '100%', overflow: 'hidden', background: bg }}>
      <Stack spacing={2} justifyContent={'space-between'} direction={'row'} flexWrap={'wrap'} sx={{ borderBottom: theme => `1px solid ${theme.palette.divider}`, mb: 2, color: theme => theme.palette.grey[500] }}>
        {title && <Typography variant="title2">{title}</Typography>}
        {actionPanel && actionPanel}
      </Stack>

      {children && (
        <Box sx={{ height: 'calc(100% - 46px)', display: 'flex', flexDirection: 'column', ...sx }}>
          {children}
        </Box>
      )}
    </Box>
  );
};

export default TileWrapper;
